import { Box, Grid2 as Grid, Tab, Tabs } from "@mui/material";

/** Icons */
import { CgNotes } from "react-icons/cg";
import { IoLayersOutline } from "react-icons/io5";
import { LabelWithIcon } from "../../../Common/Components/LabelWithIcon";

export const TabContentWrapper = ({ children, onTabChange, tab }) => {
  return (
    <Box>
      <Grid container columnSpacing={1}>
        {/* <Grid size={2}>
          <Box>
            <Tabs
              value={tab}
              onChange={onTabChange}
              orientation="vertical"
              sx={{
                "& .MuiTabs-list button": {
                  alignItems: "start", // aligns tab labels to the left
                },
                borderRight: "1px solid #0000001f",
              }}
            >
              <Tab
                label={
                  <LabelWithIcon label={"Platforms"} icon={IoLayersOutline} />
                }
                value={"platforms"}
                sx={{ textAlign: "start" }}
              />
              <Tab
                label={<LabelWithIcon label={"Content"} icon={CgNotes} />}
                value={"content"}
              />
            </Tabs>
          </Box>
        </Grid> */}
        <Grid size={12}>
          <Box sx={{ paddingLeft: "12px" }}>{children}</Box>
        </Grid>
      </Grid>
    </Box>
  );
};
